const o = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M16.125.75h-8.25a3 3 0 0 0-3 3v16.5a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3V3.75a3 3 0 0 0-3-3Z"></path><path stroke="currentColor" d="M12 3.775a.25.25 0 1 1 0-.5"></path><path stroke="currentColor" d="M12 3.775a.25.25 0 1 0 0-.5"></path></svg>';
export {
  o as default
};
